/* eslint-disable max-len */
import React from 'react';
import {
  makeStyles, Box, Typography, Divider,
} from '@material-ui/core';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

import Address from 'common/components/Address';
import DisplayMoney from 'utils/displayMoney';

import { withTranslation } from 'config/i18n';

const useStyles = makeStyles((theme) => ({
  prices: {
    display: 'flex',

    '& > div': {
      flexGrow: '1',

      '&:nth-child(2)': {
        paddingLeft: theme.spacing(1),
        marginLeft: theme.spacing(1),
        borderLeft: `1px solid ${theme.palette.grey['100']}`,
      },
    },
  },
  priceHolder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: '1',
  },
  both: {
    flexDirection: 'column',

    '& $priceInner': {
      marginRight: '0',
    },
  },
  priceInner: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2),
  },
  dashed: {
    fontWeight: '500',
    textDecoration: 'line-through',
    color: theme.palette.secondary.dark,
    opacity: '0.8',
  },
  price: {
    fontWeight: '700',
  },
  perDay: {
    color: theme.palette.secondary.dark,
    fontWeight: '500',
  },
  bold: {
    fontWeight: '500',
  },
  rateLabel: {
    fontSize: theme.typography.pxToRem(10),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.secondary.light,

    '& svg': {
      fontSize: theme.typography.pxToRem(14),
      marginRight: theme.spacing(0.5),
      marginTop: theme.spacing(-0.25),
    },
  },
}));

const VehiclePriceSummary = (props) => {
  const classes = useStyles();
  const {
    t,
    bookingData,
    price,
    location,
    pricingOption,
    hourlyPrice,
  } = props;

  const isHostedHourly = pricingOption === 'hourly' || pricingOption === 'daily_and_hourly';
  const isHostedDaily = pricingOption === 'daily' || pricingOption === 'daily_and_hourly';
  const formattedLocation = location
    && `${location.address.geo.name} ${
      location.address.region?.code
        ? `, ${location.address.region.code} ${location.address.postal_code}`
        : ''
    }`;

  return (
    <Box>
      <Box className={classes.prices}>
        {isHostedDaily && (
        <Box>
          {isHostedDaily && isHostedHourly && (
            <Box className={classes.rateLabel}>
              <CalendarTodayIcon />
              {t('fe_es_vehicle_page:daily_rate')}
            </Box>
          )}
          <Box
            className={`${classes.priceHolder} ${
              isHostedHourly && isHostedDaily ? classes.both : ''
            }`}
          >
            {bookingData?.quote
            && bookingData.quote.price_per_day
            && bookingData.quote.price_per_day.before !== bookingData.quote.price_per_day.after ? (
              <>
                <Box className={classes.priceInner}>
                  <Typography variant="h2" component="div" className={classes.price}>
                    {DisplayMoney(bookingData.quote.price_per_day.after)}
                  </Typography>
                  <Typography variant="h5" component="div" className={classes.perDay}>
                    {t('fe_es_vehicle_page:per_day')}
                  </Typography>
                </Box>

                <Typography variant="h4" component="div" className={classes.dashed}>
                  {DisplayMoney(bookingData.quote.price_per_day.before)}
                </Typography>
              </>
              ) : (
                <Box className={classes.priceInner}>
                  <Typography variant="h2" component="div" className={classes.price}>
                    {price && DisplayMoney(price.day)}
                  </Typography>
                  <Typography variant="h5" component="div" className={classes.perDay}>
                    {t('fe_es_vehicle_page:per_day')}
                  </Typography>
                </Box>
              )}
          </Box>
        </Box>
        )}

        {isHostedHourly && !!hourlyPrice && (
        <Box>
          <Box className={classes.rateLabel}>
            <QueryBuilderIcon />
            {t('fe_es_vehicle_page:hourly_starts_from')}
          </Box>
          <Box
            className={`${classes.priceHolder} ${
              isHostedHourly && isHostedDaily ? classes.both : ''
            }`}
          >
            <Box className={classes.priceInner}>
              <Typography variant="h2" component="div" className={classes.price}>
                {DisplayMoney(hourlyPrice)}
              </Typography>
              <Typography variant="h5" component="div" className={classes.perDay}>
                {t('fe_es_vehicle_page:per_hour')}
              </Typography>
            </Box>
          </Box>
        </Box>
        )}
      </Box>
      <Box my={1}>
        <Divider />
      </Box>
      <Typography className={classes.bold} variant="h5">
        {t('fe_es_vehicle_page:pickUp_dropOff')}
      </Typography>
      <Box mt={1} mb={2.5}>
        <Address location={formattedLocation} linkHref="" />
      </Box>
    </Box>
  );
};

export default withTranslation(['fe_es_vehicle_page', 'fe_bike_owner_widget'])(VehiclePriceSummary);
